import { useLocale } from "../i18n";
import "../styles/price-product-context.css";

export function PriceProductContext({ name, productId }: { name: string; productId: string }) {
  const { w } = useLocale();
  return <div className="price-product-context" aria-label={w("المنتج المرتبط بالسعر", "Product being priced")}>
    <span>{w("المنتج", "Product")}</span>
    <strong>{name}</strong>
    {name !== productId && <bdi>{productId}</bdi>}
  </div>;
}
